import { useEffect, useState } from 'react';

import { usePlatformFeatureFlagEnabled } from '../../provider';

export const useDebugMode = (): boolean => {
  const enableDebugMode = usePlatformFeatureFlagEnabled('enableDebugMode');

  // Treat the first render as SSR and only read document.cookie after mount,
  // so server and client render the same thing (no hydration mismatch).
  const [isSSR, setIsSSR] = useState(true);
  useEffect(() => {
    setIsSSR(false);
  }, []);

  const hasCookie =
    !isSSR &&
    document.cookie
      .split('; ')
      .some((cookie) => cookie === 'infinex_debug=true');

  return enableDebugMode || hasCookie;
};
